import { groupBy } from 'lodash';
import { useMemo } from 'react';

import { useEntityDiagramContext } from '../contexts/entityDiagram.context';

export function useNodeSelection() {
  const { state } = useEntityDiagramContext();

  const { selectedNodes, selectedNodesForGrouping } = useMemo(() => {
    const selectedNodes = state.nodes.filter((node) => node.selected);

    const selectedNodesBySection = groupBy(
      selectedNodes,
      (node) => node.id.split(':')[0]
    );

    if (Object.keys(selectedNodesBySection).length > 1) {
      // If there are selected nodes from multiple sections, return an empty array
      return {
        selectedNodes,
        selectedNodesForGrouping: [],
      };
    }

    return {
      selectedNodes,
      selectedNodesForGrouping: selectedNodes.filter(
        (node) => node.type === 'tile' && !node.data.isGroupNode
      ),
    };
  }, [state.nodes]);

  return {
    selectedNodes,
    selectedNodesForGrouping,
  };
}
